<!-- 由 Dioa 创建于 2022-08-24 星期三 -->
<template>
  <div class="user-data">
    <div class="top-user-wrapper">
      <div class="user-info">
        <div class="avatar-wrapper">
          <img :src="userInfo.h_img" alt="" class="avatar-image" />
          <img
            class="gender-image"
            :src="
              userInfo.gender == 1
                ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-man'
                : userInfo.gender == 2
                ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-fman'
                : ''
            "
            alt=""
          />
        </div>

        <div class="user-desc">
          <div class="top-wrapper">
            <div class="user-name">{{
              userInfo.remark_name || userInfo.truename
            }}</div>
            <img
              class="user-edit-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-edit"
              alt=""
              @click="goEdit"
              v-if="coach_formal"
            />
            <div class="user-nickname">({{ userInfo.nickname }})</div>
            <div class="user-tag tag-1" v-if="numberOfPeriods">{{
              numberOfPeriods
            }}</div>
            <div class="user-tag tag-2" v-if="student_level">{{
              student_level
            }}</div>
          </div>

          <div class="bottom-wrapper">{{ now_camp_info['title'] }}</div>
        </div>
      </div>

      <div class="user-tags">
        <div
          class="user-tags-item"
          v-for="(item, index) in lab_info"
          :key="index"
          >{{ item }}</div
        >
      </div>

      <div class="user-weight">
        <div class="user-weight-item">
          <div class="weight-text">初始体重</div>
          <div class="weight-num">
            <span class="weight-count">{{ weight_info['init_weight'] }}</span>
            <span class="weight-unit">kg</span>
          </div>
        </div>

        <div class="user-weight-item">
          <div class="weight-text">目标体重</div>
          <div class="weight-num">
            <span class="weight-count">{{ weight_info['gold_weight'] }}</span>
            <span class="weight-unit">kg</span>
          </div>
        </div>

        <div class="user-weight-item">
          <div class="weight-text">当前体重</div>
          <div class="weight-num">
            <span class="weight-count">{{ weight_info['cut_weight'] }}</span>
            <span class="weight-unit">kg</span>
          </div>
        </div>
      </div>
    </div>

    <div class="top-tab-wrapper">
      <div
        class="top-tab-item topCurrentTab"
        @click="onScroll('data-conclusion')"
        >数据总结</div
      >
      <div class="top-tab-item" @click="onScroll('chnage-trend')">变化趋势</div>
      <div class="top-tab-item" @click="onScroll('clock-in')">打卡记录</div>
    </div>

    <div class="detail-wrapper">
      <div class="person-tag-wrapper">
        <div class="top-wrapper">
          <div class="left-icon-wrapper">
            <img
              class="person-tag-icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-person-tag?v=1"
              alt=""
            />
            <span class="person-tag-text">个人标签</span>
          </div>

          <div class="right-view-more" @click="goTag">
            <span>查看更多</span>
            <van-icon name="arrow" />
          </div>
        </div>

        <div
          class="bottom-tag-box"
          id="bottom-tag-box"
          :class="{ 'tag-collapse': tagCollapse }"
        >
          <div class="bottom-tags-wrapper" id="bottom-tags-wrapper">
            <template v-if="personTagList && personTagList.length">
              <div
                class="bottom-tags-item"
                :class="fTagColor(item.attr)"
                v-for="(item, index) in personTagList"
                :key="index"
                >{{ item.tag_name }}</div
              >
            </template>

            <template v-else>
              <div class="no-data">暂无数据</div>
            </template>
          </div>
        </div>

        <div
          class="collapse-wrapper"
          v-if="tagCollapseShow"
          @click="tagCollapse = !tagCollapse"
        >
          <template v-if="tagCollapse">
            <span>展开</span>
            <img
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-down-arrown"
              alt=""
            />
          </template>

          <template v-else>
            <span>收起</span>
            <img
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-down-arrown"
              alt=""
              style="transform: rotate(180deg)"
            />
          </template>
        </div>
      </div>

      <div class="risk-wrapper">
        <div class="top-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-risk-icon?v=1"
            alt=""
          />
          <span>风险提示</span>
        </div>

        <div
          class="bottom-tags-wrapper"
          v-if="riskTagList && riskTagList.length"
        >
          <div
            class="bottom-tags-item"
            v-for="(item, index) in riskTagList"
            :key="index"
          >
            <span>{{ item }}</span>
            <img
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-warn-icon?v=1"
              alt=""
            />
          </div>
        </div>
        <template v-else>
          <div class="no-data">暂无数据</div>
        </template>
      </div>

      <div class="user-divider" id="data-conclusion">数据总结</div>

      <div
        class="week-conclusion"
        v-if="
          weekData &&
          Object.keys(weekData).length &&
          weekData['s_date'] &&
          weekData['e_date']
        "
        @click="goWeekConclusion"
      >
        <div class="left-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/week-conclusion-icon"
            alt=""
          />
          <span
            >周总结
            {{
              `${weekData['s_date'].split('-')[1]}.${
                weekData['s_date'].split('-')[2]
              }`
            }}
            -
            {{
              `${weekData['e_date'].split('-')[1]}.${
                weekData['e_date'].split('-')[2]
              }`
            }}
          </span>
        </div>

        <div class="right-btn">去查看</div>
      </div>

      <div class="meal-card-data">
        <div class="top-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/meal-card-icon"
            alt=""
          />
          <span class="meal-card-title">餐卡数据</span>
          <span
            class="iconfont icon-help"
            @click="
              commonDialog(
                '学员在本营期内，早餐、午餐、晚餐打卡的数据。打卡率计算规则：（实际打卡÷应打卡）*100%'
              )
            "
          ></span>
        </div>

        <div class="meal-card-count-box">
          <div class="meal-card-count-title">
            <div class="meal-card-count-left-text">餐卡总次数</div>

            <div class="meal-card-count-right-text">
              <div>
                <span class="meal-card-current-num">{{
                  mealCardInfo['sumMeal'] || '--'
                }}</span>
                <span class="meal-card-count-num"
                  >/{{ mealCardInfo['needMeal'] || '--' }}次</span
                >
              </div>

              <div class="meal-card-count-rate">{{
                mealCardInfo['mealRate']
              }}</div>
            </div>
          </div>

          <div class="meal-card-count-detail">
            <div class="meal-card-count-detail-item">
              <div class="meal-card-count-detail-item-top-text">早餐</div>
              <div class="meal-card-count-detail-item-bottom-wrapper">
                <div class="left-count"
                  >{{ mealCardInfo['breakfastCount'] || '--' }}次</div
                >
                <div class="center-line"></div>
                <div class="right-rate">{{
                  mealCardInfo['breakfastRate'] || '--'
                }}</div>
              </div>
            </div>

            <div class="meal-card-count-line"></div>

            <div class="meal-card-count-detail-item">
              <div class="meal-card-count-detail-item-top-text">午餐</div>
              <div class="meal-card-count-detail-item-bottom-wrapper">
                <div class="left-count"
                  >{{ mealCardInfo['lunchCount'] || '--' }}次</div
                >
                <div class="center-line"></div>
                <div class="right-rate">{{
                  mealCardInfo['lunchRate'] || '--'
                }}</div>
              </div>
            </div>

            <div class="meal-card-count-line"></div>

            <div class="meal-card-count-detail-item">
              <div class="meal-card-count-detail-item-top-text">晚餐</div>
              <div class="meal-card-count-detail-item-bottom-wrapper">
                <div class="left-count"
                  >{{ mealCardInfo['dinnerCount'] || '--' }}次</div
                >
                <div class="center-line"></div>
                <div class="right-rate">{{
                  mealCardInfo['dinnerRate'] || '--'
                }}</div>
              </div>
            </div>
          </div>

          <!-- <div class="meal-card-count-tip">同期排名01</div> -->
        </div>

        <div class="meal-card-avarage-box">
          <div class="meal-card-avarage-title">
            <div class="meal-card-avarage-left-text">餐卡平均得分</div>

            <div class="meal-card-avarage-right-text">
              <span>{{ mealCardInfo['totalAscore'] || '--' }}</span>
              <span>分</span>
            </div>
          </div>

          <div class="meal-card-avarage-detail">
            <div class="meal-card-avarage-detail-item">
              <div class="meal-card-avarage-detail-item-top-text">早餐</div>
              <div class="meal-card-avarage-detail-item-bottom-wrapper">
                {{ mealCardInfo['breakfastAscore'] || '--' }}分
              </div>
            </div>

            <div class="meal-card-avarage-line"></div>

            <div class="meal-card-avarage-detail-item">
              <div class="meal-card-avarage-detail-item-top-text">午餐</div>
              <div class="meal-card-avarage-detail-item-bottom-wrapper">
                {{ mealCardInfo['lunchAscore'] || '--' }}分
              </div>
            </div>

            <div class="meal-card-avarage-line"></div>

            <div class="meal-card-avarage-detail-item">
              <div class="meal-card-avarage-detail-item-top-text">晚餐</div>
              <div class="meal-card-avarage-detail-item-bottom-wrapper">
                {{ mealCardInfo['dinnerfastAscore'] || '--' }}分
              </div>
            </div>
          </div>

          <!-- <div class="meal-card-avarage-tip">同期排名21</div> -->
        </div>

        <div class="meal-card-top-box">
          <div class="meal-card-top-title"> 餐卡特点 TOP10 </div>
          <div class="meal-card-bottom-wrapper">
            <template
              v-if="mealCardCharacteristics && mealCardCharacteristics.length"
            >
              <div
                class="meal-card-top-item"
                v-for="(item, index) in mealCardCharacteristics"
                :key="index"
                :class="fTopTagColor(item.type)"
              >
                <span>{{ item.label_name }}</span>
                <span v-if="item.label_num">({{ item.label_num }})</span>
              </div>
            </template>

            <template v-else>
              <div class="no-data">暂无数据</div>
            </template>
          </div>
        </div>
      </div>

      <div class="cervix-data">
        <div class="top-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-cervix-icon"
            alt=""
          />
          <span class="cervix-data-title">体测数据</span>
          <span
            class="iconfont icon-help"
            @click="
              commonDialog(
                '学员在本营期内进行体测打卡的数据。打卡率计算规则：（实际打卡÷应打卡）*100%'
              )
            "
          ></span>
        </div>

        <div class="cervix-data-count-box">
          <div class="cervix-data-count-title">
            <div class="cervix-data-count-left-text">体测次数</div>

            <div class="cervix-data-count-right-text">
              <span class="cervix-data-count-num">{{
                mealCardInfo['tc_count'] || '--'
              }}</span>
              <span class="cervix-data-count-unit">次</span>
            </div>
          </div>

          <div class="cervix-data-count-detail">
            <div class="cervix-data-count-detail-item">
              <div class="cervix-data-count-detail-item-top-text">入营体测</div>
              <div class="cervix-data-count-detail-item-bottom-wrapper">
                <div class="left-count">
                  {{
                    mealCardInfo['first_tc_data'] &&
                    mealCardInfo['first_tc_data']['weight']
                      ? `${mealCardInfo['first_tc_data']['weight']}kg`
                      : '--'
                  }}
                </div>
                <div class="center-line"></div>
                <div class="right-rate">
                  {{
                    mealCardInfo['first_tc_data'] &&
                    mealCardInfo['first_tc_data']['height']
                      ? `${mealCardInfo['first_tc_data']['height']}cm`
                      : '--'
                  }}
                </div>
              </div>
            </div>

            <div class="cervix-data-count-line"></div>

            <div class="cervix-data-count-detail-item">
              <div class="cervix-data-count-detail-item-top-text">最新体测</div>
              <div class="cervix-data-count-detail-item-bottom-wrapper">
                <div class="left-count">
                  {{
                    mealCardInfo['newest_tc_data'] &&
                    mealCardInfo['newest_tc_data']['weight']
                      ? `${mealCardInfo['newest_tc_data']['weight']}kg`
                      : '--'
                  }}
                </div>
                <div class="center-line"></div>
                <div class="right-rate">
                  {{
                    mealCardInfo['newest_tc_data'] &&
                    mealCardInfo['newest_tc_data']['height']
                      ? `${mealCardInfo['newest_tc_data']['height']}cm`
                      : '--'
                  }}
                </div>
              </div>
            </div>

            <div class="cervix-data-count-line"></div>

            <div class="cervix-data-count-detail-item">
              <div class="cervix-data-count-detail-item-top-text">结营体测</div>
              <div class="cervix-data-count-detail-item-bottom-wrapper">
                <div class="left-count">
                  {{
                    mealCardInfo['end_tc_data'] &&
                    mealCardInfo['end_tc_data']['weight']
                      ? `${mealCardInfo['end_tc_data']['weight']}kg`
                      : '- -'
                  }}
                </div>
                <div class="center-line"></div>
                <div class="right-rate">
                  {{
                    mealCardInfo['end_tc_data'] &&
                    mealCardInfo['end_tc_data']['height']
                      ? `${mealCardInfo['end_tc_data']['height']}cm`
                      : '- -'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sport-data">
        <div class="top-wrapper">
          <img
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-sport-icon"
            alt=""
          />
          <span class="sport-data-title">运动数据</span>
          <span
            class="iconfont icon-help"
            @click="commonDialog('学员在本营期内进行运动打卡的数据')"
          ></span>
        </div>

        <div class="bottom-wrapper">
          <div class="left-text">运动次数</div>
          <div class="right-text">
            <span class="right-num">{{
              mealCardInfo['sport_count'] || '--'
            }}</span>
            <span class="right-unit">次</span>
          </div>
        </div>
      </div>

      <div class="user-divider" id="chnage-trend">变化趋势</div>

      <div class="weight-change-wrapper">
        <div class="weight-tab-wrapper">
          <div
            class="weight-tab-item"
            v-for="(item, index) in weightTabList"
            :key="index"
            :class="{ currentWeightTab: weightTabKey == index }"
            @click="changeWeightTab(index)"
            >{{ item.label }}</div
          >
        </div>

        <div class="weight-change-detail">
          <van-dropdown-menu class="select">
            <van-dropdown-item
              class="select-item"
              v-model="curPid"
              :options="campList"
              @change="bindChangePid"
            />
          </van-dropdown-menu>
          <div class="top-title-wrapper">
            <div class="left-wrapper">
              <img
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-weight-icon"
                alt=""
              />
              <span class="weight-change-title">
                {{
                  weightTabKey == 0
                    ? '体重变化'
                    : weightTabKey == 1
                    ? '腰围变化'
                    : 'BMI变化'
                }}
              </span>
              <template v-if="weightTabKey != 2">
                <span class="weight-change-unit"
                  >单位：{{ weightTabKey == 0 ? 'KG' : 'CM' }}</span
                >
              </template>
            </div>

            <!-- <div class="right-wrapper">
              <span>历史变化</span>
              <img
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-weight-right-arrown"
                alt=""
              />
            </div> -->
          </div>

          <div class="weight-change-box">
            <div class="left-wrapper">
              <span class="left-text-1">变化</span>
              <span class="left-text-2">{{ trendBaseInfo.change }}</span>
              <img
                :src="
                  trendBaseInfo.status == 1
                    ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-weight-arrown-up'
                    : trendBaseInfo.status == 2
                    ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-weight-arrown-down'
                    : ''
                "
                alt=""
              />
            </div>

            <div class="weight-change-line"></div>

            <div class="right-wrapper">
              <div class="right-wrapper-item">
                <span>{{
                  weightTabKey == 0
                    ? '初始体重'
                    : weightTabKey == 1
                    ? '初始腰围'
                    : '初始BMI'
                }}</span>
                <span>{{ trendBaseInfo.init }}</span>
              </div>

              <div class="right-wrapper-item">
                <span>{{
                  weightTabKey == 0
                    ? '当前体重'
                    : weightTabKey == 1
                    ? '当前腰围'
                    : '当前BMI'
                }}</span>
                <span>{{ trendBaseInfo.current }}</span>
              </div>
            </div>
          </div>

          <weightChart
            :chartData="trendBaseInfo.chartData"
            :timeData="trendBaseInfo.timeData"
            :weightTabKey="weightTabKey"
          />
        </div>
      </div>

      <div class="user-divider" id="clock-in"> 打卡记录</div>

      <div class="clock-record">
        <div class="clock-stick-wrapper">
          <div class="clock-tab-wrapper">
            <div
              class="clock-tab-item"
              v-for="(item, index) in clockTabList"
              :key="index"
              :class="{ currentClockTab: clockTabKey == item.value }"
              @click="changeClockTab(item.value)"
              >{{ item.label }}
            </div>
          </div>

          <div class="s-content">
            <div class="s-item" @click="bindBefore">
              <span class="before iconfont icon-xiala"></span
              ><span>{{ beforeMonth }}月</span>
            </div>
            <div class="s-title">{{ curYear }}年{{ curMonth }}月</div>
            <div class="s-item" @click="bindAfter">
              <span>{{ afterMonth }}月</span
              ><span class="after iconfont icon-xiala"></span>
            </div>
          </div>
        </div>

        <div class="calendar-wrapper">
          <van-calendar
            title="日历"
            color="#6236FF"
            :show-title="false"
            :show-subtitle="false"
            :poppable="false"
            :show-confirm="false"
            :min-date="calendarTimeData.minDate"
            :max-date="calendarTimeData.maxDate"
            :default-date="calendarTimeData.default"
            :formatter="calendarFormatter"
            @select="calendarSelect"
          />

          <div
            class="meal-list"
            v-if="mealDateData.list && mealDateData.list.length"
          >
            <div
              class="meal-item"
              v-for="(item, index) in mealDateData.list"
              :key="index"
              @click.stop="goDetail(item)"
            >
              <div class="left-line">
                <div class="dot"></div>
                <div class="line"></div>
              </div>
              <div class="meal-top">
                <span class="name">{{ filterCardType(item) }}</span>
                <span class="time">{{ item.addtime | filterAddTime }}</span>
                <span class="score">{{
                  item.p_average_score | filterScore
                }}</span>
              </div>
              <div class="meal-say">{{ item.say }}</div>
              <div class="meal-image-list">
                <img
                  class="meal-image-item"
                  :src="imageitem"
                  alt=""
                  v-for="(imageitem, imageindex) in item.content"
                  :key="imageindex"
                  v-show="imageindex < 4"
                  @click.stop="bindPreviewImage(item.content, imageindex)"
                />
                <div class="image-count" v-if="item.content.length > 4">
                  +{{ item.content.length - 4 }}
                </div>
              </div>
              <div class="meal-tag">
                <span
                  class="meal-tag-item"
                  v-for="(tagitem, tagindex) in item.p_label"
                  :style="{ color: filterTag(tagitem.type) }"
                  :key="tagindex"
                  >{{ tagitem.label }}</span
                >
              </div>
              <div class="meal-data-box" v-if="clockTabKey == 2">
                <div class="meal-data-item">
                  <span class="meal-data-title">体重: </span>
                  <span class="meal-data-num"
                    >{{ item['weight'] || '--' }}KG</span
                  >
                </div>

                <div class="meal-data-item">
                  <span class="meal-data-title">腰围: </span>
                  <span class="meal-data-num"
                    >{{ item['waist'] || '--' }}CM</span
                  >
                </div>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="no-data" style="padding-bottom: 20px">暂无数据</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weightChart from './ponents/weight-chart.vue'

import { ImagePreview } from 'vant'

export default {
  name: 'user-data',

  components: {
    weightChart
  },

  props: {},

  data() {
    return {
      // 参数
      unify_id: this.$route.query?.unify_id,
      pid: this.$route.query?.pid,
      campList: [],
      curPid: +this.$route.query?.pid,
      // 用户数据
      userInfo: {
        h_img: '',
        remark_name: '',
        truename: '',
        gender: ''
      },
      coach_formal: false,
      student_level: '',
      numberOfPeriods: '',
      weight_info: {},
      now_camp_info: {},
      lab_info: [],

      // 餐卡数据
      mealCardInfo: {},

      // 餐卡特点
      mealCardCharacteristics: [],

      // 变化趋势
      trendInfo: {
        weight_trend_data: []
      },

      // 周总结
      weekData: {},

      // 制定天数餐卡数据
      mealDateData: [],

      personTagList: [],
      tagCollapse: true,
      tagCollapseShow: false,

      riskTagList: [],

      weightTabKey: 0,

      weightTabList: [
        {
          label: '体重',
          value: 0
        },
        {
          label: '腰围',
          value: 1
        },
        {
          label: 'BMI',
          value: 2
        }
      ],

      clockTabList: [
        {
          label: '饮食打卡',
          value: 3
        },
        {
          label: '体测打卡',
          value: 2
        },
        {
          label: '运动打卡',
          value: 4
        }
      ],
      clockTabKey: 3,

      calendarData: [],
      currentSelectDate: '',
      calendarTimeData: {
        maxTime: '', //最大年月
        minTime: '', //最小年月
        curTime: '', //当前年月
        minDate: '', //日历组件的最小时间
        maxDate: '', //日历组件的最大时间
        default: '' //默认选中时间
      }
    }
  },

  computed: {
    beforeMonth() {
      let curTime = this.calendarTimeData.curTime
      let curMonth = parseInt(curTime.split('-')[1])
      let beforeMonth = --curMonth
      return beforeMonth || 12
    },
    afterMonth() {
      let curTime = this.calendarTimeData.curTime
      let curMonth = parseInt(curTime.split('-')[1])
      let afterMonth = ++curMonth
      return afterMonth % 12 || 12
    },
    curMonth() {
      let curTime = this.calendarTimeData.curTime
      return curTime.split('-')[1]
    },
    curYear() {
      let curTime = this.calendarTimeData.curTime
      return curTime.split('-')[0]
    },
    trendBaseInfo() {
      let timeData = this.trendInfo?.weight_trend_data.map(
        (item) => item.createTime.split(' ')[0]
      )
      switch (this.weightTabKey) {
        case 0: {
          let chartData = this.trendInfo?.weight_trend_data.map(
            (item) => item.weight
          )
          return {
            init: this.trendInfo?.current_data?.init_weight,
            current: this.trendInfo?.current_data?.current_weight,
            status: this.trendInfo?.current_data?.weight_status?.status,
            change: this.trendInfo?.current_data?.weight_status?.change,
            chartData,
            timeData
          }
        }

        case 1: {
          let chartData = this.trendInfo?.weight_trend_data.map(
            (item) => item.waist
          )
          return {
            init: this.trendInfo?.current_data?.init_waist,
            current: this.trendInfo?.current_data?.current_waist,
            status: this.trendInfo?.current_data?.waist_status?.status,
            change: this.trendInfo?.current_data?.waist_status?.change,
            chartData,
            timeData
          }
        }

        case 2: {
          let chartData = this.trendInfo?.weight_trend_data.map(
            (item) => item.bmi
          )
          return {
            init: this.trendInfo?.current_data?.init_bmi,
            current: this.trendInfo?.current_data?.current_bmi,
            status: this.trendInfo?.current_data?.bmi_status?.status,
            change: this.trendInfo?.current_data?.bmi_status?.change,
            chartData,
            timeData
          }
        }

        default: {
          return {
            init: 0,
            current: 0,
            status: 0,
            change: 0,
            chartData: [],
            timeData: []
          }
        }
      }
    }
  },

  watch: {},

  created() {
    let cur = new Date()
    let year = cur.getFullYear()
    let month = cur.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let date = cur.getDate()
    date = date < 10 ? '0' + date : date
    let monthTime = year + '-' + month
    let dayTime = year + '-' + month + '-' + date
    this.calendarTimeData.maxTime = dayTime
    this.calendarTimeData.curTime = dayTime
    this.calendarTimeData.minDate = new Date(this.dealIOS(monthTime + '-01'))
    this.calendarTimeData.maxDate = new Date(this.dealIOS(dayTime))
    this.calendarTimeData.default = new Date(this.dealIOS(dayTime))
  },

  mounted() {
    // 获取日历count
    let now = new Date()
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let monthStr = year + '-' + month

    // 获取餐卡数据
    let date = now.getDate()
    date = date < 10 ? '0' + date : date
    let dayStr = year + '-' + month + '-' + date

    this.initData(monthStr, dayStr)
  },

  destroyed() {},

  filters: {
    filterScore(score) {
      if (score || score === 0) {
        return score + '分'
      }
      return ''
    },
    filterAddTime(str = '') {
      return str.split(' ')[1] || ''
    }
  },

  methods: {
    goDetail(item) {
      if (item.version_type == 2) {
        wx.miniProgram.navigateTo({
          url:
            '/package-ugc/pages/dynamic-detail-v2/index' +
            '?tab_type=weapp_group' +
            '&tid=' +
            item.id
        })
      } else {
        wx.miniProgram.navigateTo({
          url:
            '/package-ugc/pages/dynamicDetail/dynamicDetail' +
            '?tab_type=weapp_group' +
            '&tid=' +
            item.id
        })
      }
    },
    filterCardType(cardItem) {
      let str = ''
      if (this.clockTabKey == 3) {
        let typeObj = {
          0: '早餐卡',
          1: '午餐卡',
          2: '晚餐卡',
          3: '加餐卡'
        }
        str = typeObj[cardItem.curMeal || 0]
      } else if (this.clockTabKey == 2) {
        let typeObj = {
          0: '入营体测',
          1: '日常体测',
          2: '结营体测'
        }
        str = typeObj[cardItem.type2 || 0]
      } else {
        str = '运动打卡'
      }
      return str
    },

    bindPreviewImage(list, index) {
      ImagePreview({
        images: list,
        startPosition: index
      })
    },

    filterTag(type) {
      let arr = [
        'rgba(43, 183, 155, 1)',
        'rgba(240, 70, 70, 1)',
        'rgba(0, 0, 0, 1)'
      ]
      let index = type - 1
      index = index < 0 ? 0 : index
      return arr[index] || arr[arr.length - 1]
    },

    // 日历选择
    async calendarSelect(nowDate) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      let year = nowDate.getFullYear()
      let month = nowDate.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let date = nowDate.getDate()
      date = date < 10 ? '0' + date : date
      let dayStr = year + '-' + month + '-' + date
      this.currentSelectDate = dayStr
      await this.getMemberDateData(dayStr)
      this.$toast.clear()
    },

    //处理ios时间字符串中带-转换失败的问题
    dealIOS(str) {
      return str.replace(/-/g, '/')
    },

    // 进入用户备注页
    goEdit() {
      this.$router.push({
        name: 'user-mark',
        query: {
          unify_id: this.unify_id,
          pid: this.pid
        }
      })
    },

    // 进入个人标签
    goTag() {
      this.$router.push({
        name: 'user-tag',
        query: {
          unify_id: this.unify_id,
          pid: this.pid
        }
      })
    },

    // 获取用户基本信息
    getUserInfo() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/StudentData/getStudentBasicInfo',
          {
            unify_id: this.unify_id,
            pid: this.pid
          }
        )
        if (res?.data?.code == 200) {
          this.userInfo = res?.data?.data?.user_info
          this.student_level = res?.data?.data?.student_level
          this.numberOfPeriods = res?.data?.data?.numberOfPeriods
          this.weight_info = res?.data?.data?.weight_info
          this.now_camp_info = res?.data?.data?.now_camp_info
          this.lab_info = res?.data?.data?.lab_info
          this.coach_formal = res?.data?.data?.coach_formal
          let campList = res?.data?.data?.all_camp?.map((item) => {
            item.text = item.title
            item.value = item.id
            return item
          })
          campList.unshift({ text: '全部营期', value: '' })
          this.campList = campList
        }
        resolve()
      })
    },

    // 获取用户tag
    getUserTag() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getBaseApp('member/UserTag/getUserTag', {
          uid: this.unify_id
        })
        if (res?.data?.code == 200) {
          this.personTagList = res?.data?.data

          this.$nextTick(() => {
            let maxHeight =
              document.getElementById('bottom-tag-box').offsetHeight

            let tagWrapperHeight = document.getElementById(
              'bottom-tags-wrapper'
            ).offsetHeight

            if (tagWrapperHeight > maxHeight + 5) {
              this.tagCollapse = true
              this.tagCollapseShow = true
            } else {
              this.tagCollapse = false
              this.tagCollapseShow = false
            }
          })
        }

        resolve()
      })
    },

    // 获取风险提示
    getRiskData() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http
          .getApp('member/StudentData/getRiskStatement', {
            pid: this.pid,
            unify_id: this.unify_id
          })
          .catch(() => {
            resolve()
          })
        resolve()
        if (res?.data?.code == 200) {
          this.riskTagList = res?.data?.data
        }
      })
    },

    // 获取餐卡数据
    getFoodCardData() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp('member/StudentData/getCampData', {
          pid: this.pid,
          unify_id: this.unify_id
        })
        if (res?.data?.code == 200) {
          let {
            breakfastAscore,
            breakfastCount,
            breakfastRate,
            dinnerCount,
            dinnerRate,
            dinnerfastAscore,
            lunchAscore,
            lunchCount,
            lunchRate,
            mealRate,
            needMeal,
            sport_count,
            sumMeal,
            tc_count,
            totalAscore,
            first_tc_data,
            newest_tc_data,
            end_tc_data
          } = res?.data?.data || {}

          this.mealCardInfo = {
            breakfastAscore,
            breakfastCount,
            breakfastRate,
            dinnerCount,
            dinnerRate,
            dinnerfastAscore,
            lunchAscore,
            lunchCount,
            lunchRate,
            mealRate,
            needMeal,
            sport_count,
            sumMeal,
            tc_count,
            totalAscore,
            first_tc_data,
            newest_tc_data,
            end_tc_data
          }
        }
        resolve()
      })
    },

    // 获取餐卡特点
    getMealCardCharacteristics() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/NutritionistComments/getUserLatelySevenDaysLab',
          { unify_id: this.unify_id }
        )

        if (res?.data?.code == 200) {
          this.mealCardCharacteristics = res?.data?.data?.content
        }

        resolve()
      })
    },
    bindChangePid(value) {
      this.getTrend()
    },
    // 获取趋势图
    getTrend() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/StudentData/userCampDataTrendPic',
          { unify_id: this.unify_id, pid: this.curPid }
        )
        if (res?.data?.code == 200) {
          this.trendInfo = res?.data?.data
        }
        resolve()
      })
    },

    // 获取学员餐卡分析
    getMemberMealCardAnalysis(date) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/StudentData/getUserMonthMealCardStatistics',
          {
            unify_id: this.unify_id,
            p_type: this.clockTabKey,
            month: date
          }
        )
        if (res?.data?.code == 200) {
          this.calendarData = res?.data?.data?.all_month_data
        }
        resolve()
      })
    },

    // 获取指定日期学员餐卡数据
    getMemberDateData(date) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/StudentData/getUserMealCardRecordByDate',
          {
            unify_id: this.unify_id,
            date,
            p_type: this.clockTabKey
          }
        )

        if (res?.data?.code == 200) {
          this.mealDateData = this.dealData(res?.data?.data)
        }

        resolve()
      })
    },

    dealData(data) {
      if (data.list && Array.isArray(data.list)) {
        data.list.map((item) => {
          item.content = item.content.split(',') || []
        })
      }
      return data
    },

    // 获取最新周总结
    getNewestConclusion() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let res = await this.$http.getApp(
          'member/CampWeekly/getUserNewestWeekly',
          // { uid: 75135, pid: 2130 }
          { uid: this.unify_id, pid: this.pid }
        )

        if (res.data.code == 200) {
          this.weekData = res.data.data
        }
        resolve()
      })
    },

    // 前往最新周总结
    goWeekConclusion() {
      this.$router.push({
        name: 'summary-list',
        query: {
          uid: this.weekData.uid || this.weekData.unify_id,
          pid: this.weekData.pid,
          cid: this.weekData.cid
        }
      })
    },

    // 获取数据
    initData(date, dayStr) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      try {
        Promise.all([
          this.getUserInfo(),
          this.getUserTag(),
          this.getTrend(),
          this.getFoodCardData(),
          this.getMealCardCharacteristics(),
          this.getMemberMealCardAnalysis(date),
          this.getMemberDateData(dayStr),
          this.getRiskData(),
          this.getNewestConclusion()
        ]).finally(() => {
          this.$toast.clear()
        })
      } catch (err) {
        this.$toast.clear()
      }
    },

    fTagColor(type) {
      switch (type) {
        case 2: {
          return 'red'
        }
        case 1: {
          return 'green'
        }
        case 3: {
          return 'blue'
        }
      }
    },

    fTopTagColor(type) {
      switch (type) {
        case 1: {
          return 'green'
        }
        case 2: {
          return 'red'
        }
      }
    },

    changeWeightTab(index) {
      this.weightTabKey = index
    },

    async changeClockTab(index) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.clockTabKey = index
      let yearMonth = this.calendarTimeData.curTime.slice(0, 7)
      this.calendarData = []
      this.mealDateData = []
      await this.getMemberMealCardAnalysis(yearMonth)

      let month = new Date().getMonth() + 1
      month = month < 10 ? '0' + month : month
      let saveDayStr = `${new Date().getFullYear()}-${month}-${new Date().getDate()}`
      await this.getMemberDateData(this.currentSelectDate || saveDayStr)
      this.$toast.clear()
    },

    calendarFormatter(day) {
      const year = day.date.getFullYear()
      const month = day.date.getMonth() + 1
      const date = day.date.getDate()

      let saveArr = this.calendarData.filter((item) => {
        if (item && item.curDate) {
          let saveYear = item.curDate.split('-')[0]
          let saveMonth = item.curDate.split('-')[1]
          let saveDay = item.curDate.split('-')[2]
          return year == saveYear && month == saveMonth && date == saveDay
        }
      })

      if (saveArr && saveArr.length) {
        day.bottomInfo = `${saveArr[0].c_count}次`
      }
      return day
    },

    bindBefore() {
      if (
        new Date(this.calendarTimeData.minDate) <=
        new Date(this.dealIOS(this.calendarTimeData.minTime))
      ) {
        this.$toast('不能再后退了')
        return
      }
      let curYear = this.curYear
      let curMonth = this.curMonth
      let beforeMonth = --curMonth
      if (beforeMonth <= 0) {
        curYear--
        curMonth = 12
      }
      let date = this.calendarTimeData.curTime.split('-')[2]
      this.calendarTimeData.curTime =
        curYear + '-' + (curMonth < 10 ? '0' + curMonth : curMonth) + '-' + date
      this.updateCalendarRange(curYear, curMonth, date)
    },

    bindAfter() {
      if (
        new Date(this.calendarTimeData.maxDate) >=
        new Date(this.dealIOS(this.calendarTimeData.maxTime))
      ) {
        this.$toast('不能再前进了')
        return
      }
      let curYear = this.curYear
      let curMonth = this.curMonth
      let afterMonth = ++curMonth
      if (afterMonth > 12) {
        curYear++
        curMonth = 1
      }
      let date = this.calendarTimeData.curTime.split('-')[2]
      this.calendarTimeData.curTime =
        curYear + '-' + (curMonth < 10 ? '0' + curMonth : curMonth) + '-' + date
      this.updateCalendarRange(curYear, curMonth, date)
    },

    //更新日历区间
    updateCalendarRange(curYear, curMonth) {
      curYear = parseInt(curYear)
      curMonth = parseInt(curMonth)
      let nextMonth = curMonth + 1
      let nextYear = curYear
      if (nextMonth > 12) {
        nextYear = curYear + 1
        nextMonth = 1
      }
      //兼容ios 时间/
      let nextTime = new Date(nextYear + '/' + nextMonth + '/01') //下个月一号
      let lastDay = nextTime.getTime() - 1000 * 60 * 60 * 24 //这个月最后一天
      lastDay = new Date(lastDay).getDate()
      this.calendarTimeData.minDate = new Date(curYear + '/' + curMonth + '/01')
      this.calendarTimeData.maxDate = new Date(
        curYear + '/' + curMonth + '/' + lastDay
      )
      let yearMonth = this.calendarTimeData.curTime.slice(0, 7)
      this.getMemberMealCardAnalysis(yearMonth)
    },

    // 提示弹窗
    commonDialog(tip) {
      this.$dialog.alert({
        message: tip,
        messageAlign: 'left',
        confirmButtonColor: '#6236ff'
      })
    },

    // 滚动
    onScroll(domId) {
      document.getElementById(domId).scrollIntoView()
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.user-data {
  background-color: #f9f9f9;
  min-height: 100vh;

  .top-user-wrapper {
    padding: vw(21) vw(20) vw(60);
    background: linear-gradient(125deg, #cdebfa 0%, #cad4fc 100%);

    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: vw(10);

      .avatar-wrapper {
        position: relative;
        margin-right: vw(15);

        .avatar-image {
          width: vw(54);
          height: vw(54);
          border-radius: vw(12);
          object-fit: cover;
        }

        .gender-image {
          position: absolute;
          bottom: 0;
          right: 0;
          width: vw(17);
        }
      }

      .user-desc {
        .top-wrapper {
          display: flex;
          align-items: center;
          margin-bottom: vw(8);

          .user-name {
            font-size: vw(18);
            font-weight: 600;
            color: #000000;
            margin-right: vw(2);
            max-width: vw(79);
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .user-edit-image {
            width: vw(14);
            height: vw(17);
          }

          .user-nickname {
            font-size: vw(12);
            font-weight: 400;
            color: #000000;
            margin: 0 vw(5);
          }

          .user-tag {
            padding: vw(2) vw(6);
            font-size: vw(10);
            font-weight: 500;
            color: #ffffff;
            border-radius: vw(4);

            &.tag-1 {
              background-color: #6236ff;
              margin-right: vw(5);
            }

            &.tag-2 {
              background-color: #db36ff;
            }
          }
        }

        .bottom-wrapper {
          font-size: vw(10);
          font-weight: 500;
          color: #000000;
        }
      }
    }

    .user-tags {
      display: flex;
      align-items: center;
      margin-bottom: vw(14);

      .user-tags-item {
        padding: vw(4) vw(14);
        box-sizing: border-box;
        text-align: center;
        font-size: vw(10);
        color: rgba(#000000, 0.6);
        background: rgba(255, 255, 255, 0.7);
        border-radius: vw(4);
        margin-right: vw(6);
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .user-weight {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .user-weight-item {
        display: flex;
        align-items: center;

        .weight-text {
          font-size: vw(10);
          font-weight: 400;
          color: rgba(#000000, 0.5);
          margin-right: vw(6);
        }

        .weight-num {
          color: #000000;
          font-weight: bold;

          .weight-count {
            font-size: vw(20);
          }

          .weight-unit {
            font-size: vw(12);
          }
        }
      }
    }
  }

  .top-tab-wrapper {
    // position: sticky;
    // top: 0;
    background-color: rgba(#fff, 0.5);
    margin-top: vw(-50);
    border-top-left-radius: vw(12);
    border-top-right-radius: vw(12);
    display: flex;
    overflow: hidden;
    z-index: 999;

    .top-tab-item {
      flex: 1;
      padding: vw(17) 0 vw(14);
      font-size: vw(14);
      font-weight: 400;
      color: rgba(#000, 0.8);
      display: flex;
      justify-content: center;
      background-color: transparent;
      border-top-left-radius: vw(12);
      border-top-right-radius: vw(12);

      &.topCurrentTab {
        background-color: #fff;
        color: #000;
        font-weight: 500;
      }
    }
  }

  .detail-wrapper {
    padding: vw(23) vw(10) vw(23);
    background: linear-gradient(#fff 0%, rgba(#000, 0) vw(469));

    .person-tag-wrapper {
      background-color: #fff;
      border-radius: vw(12);
      overflow: hidden;
      margin-bottom: vw(12);

      .top-wrapper {
        padding: vw(17) vw(13);
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/person-tag-bg');
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        .left-icon-wrapper {
          display: flex;
          align-items: center;

          .person-tag-icon {
            width: vw(20);
            object-fit: cover;
            margin-right: vw(3);
          }

          .person-tag-text {
            font-size: vw(16);
            font-weight: 500;
            color: #000000;
          }
        }

        .right-view-more {
          display: flex;
          align-items: center;
          font-size: vw(10);
          font-weight: 400;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .bottom-tag-box {
        overflow: hidden;
        height: auto;
        transition-property: all;
        transition-duration: 0.3s;

        &.tag-collapse {
          max-height: vw(135);
        }

        .bottom-tags-wrapper {
          padding: 0 vw(12) 0;
          background-color: #fff;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;

          .bottom-tags-item {
            padding: vw(7) vw(14);
            border-radius: vw(15);
            margin-bottom: vw(12);
            margin-right: vw(8);
            font-size: vw(12);
            border: 1px solid rgba(#767676, 0.1);
            color: #000;
            box-sizing: border-box;

            &:last-child {
              margin-right: 0;
            }

            &.red {
              background: linear-gradient(#f9d5ff 0%, #ffe0e0 100%);
            }

            &.green {
              background: linear-gradient(#fffef8 0%, #eefff4 100%);
            }

            &.blue {
              background: linear-gradient(#faf8ff 0%, #eefbff 100%);
            }
          }
        }
      }

      .collapse-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: vw(20);
        margin-top: vw(5);

        span {
          font-size: vw(10);
          font-weight: 400;
          color: rgba(#000000, 0.5);
          margin-right: vw(6);
        }

        img {
          width: vw(9);
        }
      }
    }

    .risk-wrapper {
      background-color: #fff;
      border-radius: vw(12);
      overflow: hidden;

      .top-wrapper {
        padding: vw(17) vw(13);
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-risk-bg');
        display: flex;
        align-items: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        img {
          width: vw(20);
          margin-right: vw(3);
        }

        span {
          font-size: vw(16);
          font-weight: 500;
          color: #000000;
        }
      }

      .bottom-tags-wrapper {
        display: flex;
        flex-wrap: wrap;
        padding: 0 vw(14) vw(10);

        .bottom-tags-item {
          padding: vw(7) vw(14);
          display: flex;
          align-items: center;
          border-radius: vw(4);
          border: 1px solid rgba(140, 143, 146, 0.1);
          background: #fff7f7;
          margin-right: vw(8);
          margin-bottom: vw(10);

          &:last-child {
            margin-right: 0;
          }

          span {
            margin-right: vw(4);
            font-size: vw(12);
            font-weight: 400;
            color: #000000;
          }

          img {
            width: vw(11);
          }
        }
      }
    }

    .user-divider {
      width: vw(220);
      margin: vw(40) auto vw(30);
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/user-divider');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      text-align: center;
      font-size: vw(14);
      font-weight: 500;
      color: #000000;
    }

    .week-conclusion {
      height: vw(60);
      box-sizing: border-box;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/week-conclusion-bg');
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 vw(16) 0 vw(13);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin-bottom: vw(10);

      .left-wrapper {
        display: flex;
        align-items: center;

        img {
          width: vw(20);
          object-fit: cover;
          margin-right: vw(3);
        }

        span {
          font-size: vw(16);
          font-weight: 500;
          color: #000000;
        }
      }

      .right-btn {
        background: #6236ff;
        border-radius: vw(14);
        color: #fff;
        padding: vw(5) vw(12);
      }
    }

    .meal-card-data {
      background-color: #fff;
      border-radius: vw(12);
      padding: vw(13) vw(12) vw(20);
      margin-bottom: vw(16);

      .top-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: vw(14);

        img {
          width: vw(20);
          object-fit: cover;
        }

        .meal-card-title {
          font-size: vw(16);
          font-weight: 500;
          color: #000000;
          margin: 0 vw(4) 0 vw(4);
        }

        .iconfont {
          font-size: vw(20);
          color: rgba(#000, 0.6);
        }
      }

      .meal-card-count-box {
        border-radius: vw(8);
        border: 1px solid #f1f1f1;
        position: relative;
        margin-bottom: vw(16);

        .meal-card-count-tip {
          position: absolute;
          top: 0;
          transform: translateY(-50%);
          right: 0;
          background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/meal-card-red-tip');
          width: vw(58);
          height: vw(15);
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          font-size: vw(9);
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: vw(8) vw(8) 0px 0px;
          overflow: hidden;
        }

        .meal-card-count-title {
          padding: vw(13) vw(20);
          background-color: #f2f2ff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: vw(8) vw(8) 0 0;

          .meal-card-count-left-text {
            font-size: vw(14);
            font-weight: 500;
            color: #000000;
          }

          .meal-card-count-right-text {
            display: flex;
            color: #000000;
            font-weight: 800;

            .meal-card-current-num {
              font-size: vw(20);
            }

            .meal-card-count-num {
              font-size: vw(12);
            }

            .meal-card-count-rate {
              font-size: vw(20);
              font-weight: 800;
              color: #000000;
              margin-left: vw(17);
            }
          }
        }

        .meal-card-count-detail {
          display: flex;
          padding: vw(12) 0;
          background-color: rgba(#fafafa, 0.5);

          .meal-card-count-detail-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;

            .meal-card-count-detail-item-top-text {
              font-size: vw(12);
              font-weight: 400;
              color: rgba(#000000, 0.5);
              margin-bottom: vw(5);
            }

            .meal-card-count-detail-item-bottom-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: vw(12);
              font-weight: 500;
              color: #000000;

              .center-line {
                height: vw(10);
                width: vw(1);
                background-color: rgba(#000, 0.1);
                margin: 0 vw(5);
              }
            }
          }

          .meal-card-count-line {
            width: 1px;
            background-color: #f1f1f1;
          }
        }
      }

      .meal-card-avarage-box {
        border-radius: vw(8);
        border: 1px solid #f1f1f1;
        position: relative;
        margin-bottom: vw(16);

        .meal-card-avarage-tip {
          position: absolute;
          top: 0;
          transform: translateY(-50%);
          right: 0;
          background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/meal-card-blue-tip');
          width: vw(58);
          height: vw(15);
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          font-size: vw(9);
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: vw(8) vw(8) 0px 0px;
          overflow: hidden;
        }

        .meal-card-avarage-title {
          padding: vw(13) vw(20);
          background-color: #f2f2ff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          align-items: center;
          border-radius: vw(8) vw(8) 0 0;

          .meal-card-avarage-left-text {
            font-size: vw(14);
            font-weight: 500;
            color: #000000;
          }

          .meal-card-avarage-right-text {
            span {
              &:first-child {
                font-size: vw(20);
                font-weight: 800;
                color: #000000;
                margin-right: vw(2);
              }

              &:last-child {
                font-size: vw(12);
                font-weight: 800;
                color: #000000;
              }
            }
          }
        }

        .meal-card-avarage-detail {
          display: flex;
          padding: vw(12) 0;
          background-color: rgba(#fafafa, 0.5);

          .meal-card-avarage-detail-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;

            .meal-card-avarage-detail-item-top-text {
              font-size: vw(12);
              font-weight: 400;
              color: rgba(#000000, 0.5);
              margin-bottom: vw(5);
            }

            .meal-card-avarage-detail-item-bottom-wrapper {
              font-size: vw(12);
              font-weight: 500;
              color: #000000;
            }
          }

          .meal-card-avarage-line {
            width: 1px;
            background-color: #f1f1f1;
          }
        }
      }

      .meal-card-top-box {
        border-radius: vw(8);
        border: 1px solid #f1f1f1;
        position: relative;

        .meal-card-top-title {
          padding: vw(13) vw(20);
          background-color: #f2f2ff;
          display: flex;
          align-items: center;
          border-radius: vw(8) vw(8) 0 0;
          font-size: vw(14);
          font-weight: 500;
          color: #000000;
        }

        .meal-card-bottom-wrapper {
          padding: vw(14) vw(10) vw(8) vw(10);
          background-color: rgba(#fafafa, 0.5);
          display: flex;
          flex-wrap: wrap;
          justify-content: center;

          .meal-card-top-item {
            padding: vw(6) vw(12);
            border-radius: vw(6);
            border: 1px solid #f1f1f1;
            font-size: vw(12);
            font-weight: 500;

            margin-right: vw(6);
            margin-bottom: vw(8);

            &:last-child {
              margin-right: 0;
            }

            &.red {
              color: #f04646;
            }

            &.black {
              color: #000;
            }

            &.green {
              color: #2bb79b;
            }
          }
        }
      }
    }

    .cervix-data {
      background-color: #fff;
      border-radius: vw(12);
      padding: vw(13) vw(12) vw(20);
      margin-bottom: vw(16);

      .top-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: vw(14);

        img {
          width: vw(20);
          object-fit: cover;
        }

        .cervix-data-title {
          font-size: vw(16);
          font-weight: 500;
          color: #000000;
          margin: 0 vw(4) 0 vw(4);
        }

        .iconfont {
          font-size: vw(20);
          color: rgba(#000, 0.6);
        }
      }

      .cervix-data-count-box {
        border-radius: vw(8);
        border: 1px solid #f1f1f1;
        position: relative;

        .cervix-data-count-title {
          padding: vw(13) vw(20);
          background-color: #f2f2ff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: vw(8) vw(8) 0 0;

          .cervix-data-count-left-text {
            font-size: vw(14);
            font-weight: 500;
            color: #000000;
          }

          .cervix-data-count-right-text {
            .cervix-data-count-num {
              font-size: vw(20);
              font-weight: 800;
              color: #000000;
              margin-right: vw(2);
            }

            .cervix-data-count-unit {
              font-size: vw(12);
              font-weight: 800;
              color: #000000;
            }
          }
        }

        .cervix-data-count-detail {
          display: flex;
          padding: vw(12) 0;
          background-color: rgba(#fafafa, 0.5);

          .cervix-data-count-detail-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;

            .cervix-data-count-detail-item-top-text {
              font-size: vw(12);
              font-weight: 400;
              color: rgba(#000000, 0.5);
              margin-bottom: vw(5);
            }

            .cervix-data-count-detail-item-bottom-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: vw(12);
              font-weight: 500;
              color: #000000;

              .center-line {
                height: vw(10);
                width: vw(1);
                background-color: rgba(#000, 0.1);
                margin: 0 vw(5);
              }
            }
          }

          .cervix-data-count-line {
            width: 1px;
            background-color: #f1f1f1;
          }
        }
      }
    }

    .sport-data {
      background-color: #fff;
      border-radius: vw(12);
      padding: vw(16) vw(14);

      .top-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: vw(12);

        img {
          width: vw(20);
          object-fit: cover;
        }

        .sport-data-title {
          font-size: vw(16);
          font-weight: 500;
          color: #000000;
          margin: 0 vw(4) 0 vw(4);
        }

        .iconfont {
          font-size: vw(20);
          color: rgba(#000, 0.6);
        }
      }

      .bottom-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: vw(16) vw(20);
        background-color: #f2f2ff;
        border-radius: vw(8);

        .left-text {
          font-size: vw(14);
          font-weight: 500;
          color: #000000;
        }

        .right-text {
          .right-num {
            font-size: vw(20);
            font-weight: 800;
            color: #000000;
            margin-right: vw(2);
          }

          .right-unit {
            font-size: vw(12);
            font-weight: 800;
            color: #000000;
          }
        }
      }
    }

    .weight-change-wrapper {
      .weight-tab-wrapper {
        width: 100%;
        padding: vw(2);
        border-radius: vw(10);
        background-color: #6236ff;
        display: flex;
        margin-bottom: vw(12);

        .weight-tab-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: vw(8);
          padding: vw(3) 0;
          font-size: vw(16);
          font-weight: 400;
          color: rgba(#ffffff, 0.5);

          &.currentWeightTab {
            background-color: #ffffff;
            color: #6236ff;
            font-weight: 500;
          }
        }
      }

      .weight-change-detail {
        position: relative;
        padding: vw(18) vw(14);
        background-color: #fff;
        border-radius: vw(12);

        .select {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 140px;
          ::v-deep .van-dropdown-menu__bar {
            height: 30px;
            border-radius: 4px;
            background: transparent;
          }
          ::v-deep .van-dropdown-menu__title {
            width: 120px;
            box-sizing: border-box;
          }
        }

        .top-title-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: vw(27);

          .left-wrapper {
            display: flex;
            align-items: center;

            img {
              width: vw(20);
              object-fit: cover;
              margin-right: vw(5);
            }

            .weight-change-title {
              font-size: vw(16);
              font-weight: 500;
              color: #000000;
              margin-right: vw(8);
            }

            .weight-change-unit {
              font-size: vw(10);
              font-weight: 400;
              color: rgba(#000000, 0.5);
            }
          }

          .right-wrapper {
            display: flex;
            align-items: center;

            span {
              font-size: vw(12);
              font-weight: 400;
              color: #000000;
              margin-right: vw(3);
            }

            img {
              width: vw(6);
              object-fit: cover;
            }
          }
        }

        .weight-change-box {
          display: flex;
          align-items: center;
          margin-bottom: vw(30);

          .left-wrapper,
          .right-wrapper {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .left-wrapper {
            flex-wrap: nowrap;

            .left-text-1 {
              font-size: vw(12);
              font-weight: 400;
              color: rgba(#000, 0.5);
              margin-right: vw(5);
            }

            .left-text-2 {
              font-size: vw(32);
              font-weight: bold;
              color: #6236ff;
              margin-right: vw(5);
            }

            img {
              width: vw(9);
            }
          }

          .weight-change-line {
            height: vw(26);
            width: vw(1);
            background-color: #f1f1f1;
          }

          .right-wrapper {
            flex-direction: column;

            .right-wrapper-item {
              margin-bottom: vw(4);
              display: flex;
              align-items: center;

              &:last-child {
                margin-bottom: 0;
              }

              span {
                &:first-child {
                  font-size: vw(12);
                  font-weight: 400;
                  color: rgba(#000, 0.5);
                  margin-right: vw(15);
                }

                &:last-child {
                  font-size: vw(16);
                  font-weight: bold;
                  color: #000000;
                  width: vw(29);
                }
              }
            }
          }
        }
      }
    }

    .clock-record {
      background-color: #fff;

      .clock-stick-wrapper {
        position: sticky;
        top: 0;
        z-index: 9;
        background-color: #fff;

        .clock-tab-wrapper {
          padding: vw(2);
          border-radius: vw(10);
          background-color: #6236ff;
          display: flex;
          margin-bottom: vw(10);

          .clock-tab-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: vw(8);
            padding: vw(3) 0;
            font-size: vw(16);
            font-weight: 400;
            color: rgba(#ffffff, 0.5);

            &.currentClockTab {
              background-color: #ffffff;
              color: #6236ff;
              font-weight: 500;
            }
          }
        }

        .s-content {
          display: flex;
          align-items: center;
          height: 32px;
          border-radius: 10px;
          padding: 0px 20px;
          // position: sticky;
          // top: vw(33);
          background-color: #fff;
          z-index: 9;

          .s-item {
            font-size: 14px;
            color: rgba(#6236ff, 0.5);
            line-height: 20px;

            .before {
              display: inline-block;
              transform: rotate(90deg);
            }

            .after {
              display: inline-block;
              transform: rotate(-90deg);
            }
          }

          .s-title {
            color: #6236ff;
            text-align: center;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 20px;
          }
        }
      }

      .calendar-wrapper {
        .meal-list {
          padding: 0 vw(20);

          .meal-item {
            position: relative;
            padding-bottom: 34px;
            padding-left: 26px;

            .left-line {
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              display: flex;
              align-items: center;
              flex-direction: column;

              .dot {
                width: 16px;
                height: 16px;
                box-sizing: border-box;
                background: #ffffff;
                border-radius: 50%;
                border: 3px solid #6236ff;
              }

              .line {
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                width: 1px;
                background-color: #f1f1f1;
              }
            }

            .meal-top {
              margin-bottom: 9px;

              .name {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.8);
                line-height: 22px;
                margin-right: 10px;
              }

              .time {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.5);
                line-height: 20px;
                margin-right: 13px;
              }

              .score {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #6236ff;
                line-height: 22px;
              }
            }

            .meal-say {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 22px;
              margin-bottom: 16px;
            }

            .meal-image-list {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              position: relative;

              .image-count {
                padding: 0px 8px;
                height: 30px;
                line-height: 30px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 7px;
                position: absolute;
                bottom: 18px;
                right: 8px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
              }

              .meal-image-item {
                width: 150px;
                height: 150px;
                background: #f1f1f1;
                border-radius: 8px;
                overflow: hidden;
                margin-bottom: 10px;
                margin-right: 8px;
                object-fit: cover;
              }

              .meal-image-item:nth-child(2n) {
                margin-right: 0;
              }
            }

            .meal-tag {
              display: flex;
              align-items: center;
              flex-wrap: wrap;

              .meal-tag-item {
                padding: 0px 20px;
                height: 24px;
                line-height: 24px;
                background: #f9f9f9;
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                border-radius: 4px;
                margin-right: 6px;
                margin-bottom: 4px;
              }
            }

            .meal-data-box {
              display: flex;
              align-items: center;
              margin-top: vw(10);

              .meal-data-item {
                margin-right: vw(20);
                font-size: vw(12);

                &:last-child {
                  margin-right: 0;
                }

                .meal-data-title {
                  color: rgba(#000, 0.5);
                  margin-right: vw(5);
                }

                .meal-data-num {
                  color: #000;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }

      ::v-deep .van-calendar__header {
        box-shadow: none;
      }

      ::v-deep .van-calendar {
        background-color: transparent;
      }

      ::v-deep .van-calendar__month-title,
      ::v-deep .van-calendar__footer {
        display: none;
      }
    }
  }

  .no-data {
    font-size: vw(14);
    text-align: center;
    color: rgba(#000, 0.5);
    margin: vw(10) 0;
  }
}
</style>
